import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from "vue";
import FindWorkOrderModal from "@/components/find/work-orders/find-work-order-modal.vue";
import { WorkOrderFindResult } from "@/types/find/work-orders/WorkOrderFindResult";
import { useRouter } from "vue-router";
import { RouteNames } from "@/router/RouteNames";


export default /*#__PURE__*/_defineComponent({
  __name: 'find-work-order',
  props: {
  /**
   * The boolean value used with `v-model` to control the visibility or state of a modal or component.
   * @type {boolean}
   * @required
   */
  modelValue: {
    type: Boolean,
    required: true,
  },
},
  emits: [
  /**
   * Triggered when the `modelValue` changes. This is used to update the v-model variable in the parent component.
   * @property {boolean} value - Indicates whether the modal has been opened or closed.
   */
  "update:modelValue",
],
  setup(__props, { emit }) {

const props = __props;





const showModal = computed({
  get: () => props.modelValue,
  set: (value: boolean) => emit("update:modelValue", value),
});

const router = useRouter();

const onWorkOrderSelected = (workerOrder: WorkOrderFindResult) => {
  if (!workerOrder?.id) {
    return;
  }

  router.push({
    name: RouteNames.WorkOrdersPage,
    params: { workorderid: workerOrder.id.toString() },
  });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(FindWorkOrderModal, {
    modelValue: showModal.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((showModal).value = $event)),
    onWorkOrderSelected: onWorkOrderSelected
  }, null, 8, ["modelValue"]))
}
}

})